import {http} from './config/config-receituario'
export default{
    listar:(token,tipo = null, skip, take)=>{
        return http.get(`contas?tipo=${tipo}&skip=${skip}&take=${take}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    findAllFlowAccount:(token,  month)=>{
        return http.get(`contas/flow-account/${month}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, conta)=>{
        return http.post('contas', conta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizarConta:(token, conta) =>{
        return http.put('contas/'+conta.id,conta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    deleteConta:(token, id)=>{
        return http.delete('contas/'+id,{
            headers:{
                'Authorization':token
            }
        })
    }
}